import type BizminerOrganizationDisplay from "@/_generated/types/serializers/BizminerOrganizationDisplay";
import { LoginForm, type SsoConfig } from "@/components/auth/LoginForm.tsx";

interface Props {
  session_url: string;
  organization_slug: string;
  dangerous_magic_url_never_on_production?: string;
  sso?: SsoConfig;
  organization?: BizminerOrganizationDisplay;
}

export default function LoginPage(props: Props) {
  return <LoginForm {...props} />;
}
